export default class Arrays {
  sum (array) {
    return array.reduce((a, b) => a + b, 0);
  }

  avr (array) {
    let total = this.sum(array)
    return total / array.length
  }

  mean (array) {
    return this.avr(array)
  }

  min (array) {
    let min = array[0]
    array.forEach(function (item) {
      if (min > item) {
        min = item
      }
    })
    return min
  }

  max (array) {
    let max = array[0]
    array.forEach(function (item) {
      if (max < item) {
        max = item
      }
    })
    return max
  }
  // 표준 편차
  dev (array) {
    let mean = this.mean(array)
    let total = 0
    for (let i = 0; i < array.length; i++) {
      let deviation = array[i] - mean
      total += deviation * deviation
    }
    return Math.sqrt(total / (array.length - 1))
  }
}
